import { useNavigate } from 'react-router-dom'

interface RegistrationIncompleteModalProps {
  isOpen: boolean
  onClose: () => void
}

export function RegistrationIncompleteModal({ isOpen, onClose }: RegistrationIncompleteModalProps) {
  const navigate = useNavigate()

  if (!isOpen) return null

  const handleCompleteRegistration = () => {
    onClose()
    navigate('/signup')
  }

  return (
    <div className="fixed inset-0 bg-black/50 flex items-center justify-center z-50">
      <div className="bg-background rounded-lg shadow-lg max-w-md w-full mx-4 p-6">
        <div className="text-center">
          <div className="w-12 h-12 mx-auto mb-4 bg-orange-100 rounded-full flex items-center justify-center">
            <svg className="w-6 h-6 text-orange-600" fill="none" stroke="currentColor" viewBox="0 0 24 24">
              <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M12 9v2m0 4h.01m-6.938 4h13.856c1.54 0 2.502-1.667 1.732-2.5L13.732 4c-.77-.833-1.964-.833-2.732 0L3.732 16.5c-.77.833.192 2.5 1.732 2.5z" />
            </svg>
          </div>
          
          <h3 className="text-lg font-semibold text-foreground mb-2">
            Registration Incomplete
          </h3>
          
          <p className="text-muted-foreground mb-6">
            Your account exists but you haven't completed the registration process yet. 
            Please complete your account setup to continue.
          </p>
          
          <div className="flex gap-3 justify-center">
            <button
              onClick={onClose}
              className="px-4 py-2 border border-border rounded-md hover:bg-muted text-foreground"
            >
              Cancel
            </button>
            <button
              onClick={handleCompleteRegistration}
              className="px-4 py-2 bg-primary text-primary-foreground rounded-md hover:bg-primary/90"
            >
              Complete Registration
            </button>
          </div>
        </div>
      </div>
    </div>
  )
} 